import BadgeV2 from '@/components/common/badge/BadgeV2';
import { BadgeBackgroundColorType, BadgeBorderColorType, BadgeKind, DotBadgeSize } from '@/types';

import styles from './AvailabilityBadge.module.scss';

type AvailabilityBadgeProps = {
  background: BadgeBackgroundColorType;
  border: BadgeBorderColorType;
  label: string;
};

export const AvailabilityBadge = ({ background, border, label }: AvailabilityBadgeProps) => (
  <div className={styles.container}>
    <BadgeV2 type={BadgeKind.DOT} size={DotBadgeSize.MEDIUM} background={background} border={border} />
    <p className={styles.label}>{label}</p>
  </div>
);

export default AvailabilityBadge;
